var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-search-select-input',{attrs:{"id":_vm.id,"options":_vm.ddiOptions,"modelValue":_vm.filters.ddi_busca,"disabled":_vm.disabled,"errorMessage":_vm.errors.id_ddi},on:{"onUpdateList":function ($event) {
      _vm.loadDDIList({ ddi_busca: $event });
    },"onSelect":function($event){return _vm.onSelectDDI($event)},"update:modelValue":function (newValue) {
      _vm.filters.ddi_busca = newValue;
    }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a26c042","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/ModalCelularDdiInput.vue
// module id = null
// module chunks = 